// Returns the device's local calendar date as YYYY-MM-DD.
// Deliberately avoids Date#toISOString(), which is UTC-based and would
// produce the wrong date near local-midnight boundaries.
const getLocalDateString = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export { getLocalDateString };
